import axios, {AxiosResponse} from 'axios';
import {IActivityXpedition} from '../activities/interfaces';

export const getActivitiesApi = (): Promise<AxiosResponse<IActivityXpedition[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/activities`
  );
};
